import * as React from 'react';
import { PopoverProvider } from '@fluentui/react-popover';
import { TeachingPopoverProvider } from '../../TeachingPopoverContext';
/**
 * Render the final JSX of TeachingPopover
 */ export const renderTeachingPopover_unstable = (state, contextValues)=>{
    const { appearance, arrowRef, contentRef, inline, mountNode, open, openOnContext, openOnHover, setOpen, size, toggleOpen, trapFocus, triggerRef, withArrow, inertTrapFocus } = state;
    return(// Popover passes context values as part of PopoverState that we inherit
    /*#__PURE__*/ React.createElement(PopoverProvider, {
        value: {
            appearance,
            arrowRef,
            contentRef,
            inline,
            mountNode,
            open,
            openOnContext,
            openOnHover,
            setOpen,
            toggleOpen,
            triggerRef,
            size,
            trapFocus,
            inertTrapFocus,
            withArrow
        }
    }, /*#__PURE__*/ React.createElement(TeachingPopoverProvider, {
        value: contextValues.teachingPopover
    }, state.popoverTrigger, state.open && state.popoverSurface)));
};
